var render, staticRenderFns
import script from "./SingleValue.vue?vue&type=script&lang=js&"
export * from "./SingleValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleValue.vue"
export default component.exports